import angular from 'angular';
import 'angular-filter';
import 'angular-ui-router';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import template from './header-segments.jade';

export class HeaderSegmentsController {
  /* @ngInject */
  constructor($q, $state, $stateParams, SegmentsResource) {
    this.$q = $q;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.SegmentsResource = SegmentsResource;
    this.getSegments();
  }

  getSegments() {
    let game_id = this.$stateParams.gameId;

    return this.SegmentsResource.getList({game_id}).then((segments) => {
      this.segments = segments;
    });
  }

  goToSegment(segment) {
    let params = _.merge({}, this.$stateParams, {id: segment.id});

    if (segment.type == 'for_sale') {
    } else {
      this.$state.go('app.segments.showEngage', params);
    }
  }
}

export function HeaderSegmentsComponent() {
  return {
    template,
    controller: HeaderSegmentsController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      segment: '='
    },
    bindToController: true,
    link: function (scope, element) {
      element.addClass('c-header-primary__item c-header-primary__item--fill');
    }
  };
};

export default angular.module('header.segments', [
  'ui.router',
  'ui.select',
  'angular.filter',
  ServicesModule.name,
  ResourcesModule.name
])
  .directive('headerSegments', HeaderSegmentsComponent);


/** WEBPACK FOOTER **
 ** ./src/common/header/header-segments.js
 **/